import { cva, type VariantProps } from 'class-variance-authority'
import { Label as LabelPrimitive } from 'radix-ui'
import * as React from 'react'

import { cn } from '@/legacy-src/lib/utils'

import { Text, type TextProps } from '@/src/domains/design-system/components/Text'

const labelVariants = cva(
  'mb-0 cursor-pointer before:content-none after:content-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
  {
    variants: {
      variant: {
        default: '',
        'selection-control':
          'text-petrol-500 peer-hover:text-petrol-300 hover:peer-hover:text-petrol-300 peer-disabled:text-sand-700 peer-disabled:opacity-100 peer-disabled:peer-hover:text-sand-700',
      },
      size: {
        s: '',
        m: '',
        l: '',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'm',
    },
  },
)

interface LabelVariantProps extends VariantProps<typeof labelVariants> {}

export interface LabelProps extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>, LabelVariantProps {
  weight?: TextProps['weight']
}

const textSizeMap: Record<NonNullable<LabelProps['size']>, TextProps['variant']> = {
  s: 'xs',
  m: 'base',
  l: 'lg',
}

export const Label = React.forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, variant, size, weight, ...props }, ref) => (
    <Text
      asChild
      variant={textSizeMap[size ?? 'm']}
      weight={weight ?? 'regular'}
      className={cn(labelVariants({ variant, className }), 'custom-control-label')}
    >
      <LabelPrimitive.Root ref={ref} {...props} />
    </Text>
  ),
)

Label.displayName = LabelPrimitive.Root.displayName
